import { createAction, props } from '@ngrx/store';
import { ICountry } from '../../models/country.model';

// reducer actions
export const setCountries = createAction('[Country] SET COUNTRIES', props<{ countries: ICountry[] }>());

// effects actions
export const setCountriesEffect = createAction('[Country] SET COUNTRIES EFFECT');
